import { COMMUNITY_KIND, DELIVERY_METHOD } from '@/types';

export const COMMUNITY_VIRTUAL_ALL_ID = 'all';

export const MAX_COMMUNITY_LIST_NAME_LENGTH = 255;
export const MAX_COMMUNITY_LIST_DESCRIPTION_LENGTH = 70;

export const MAX_COMMUNITY_CARD_NAME_LENGTH = 255;
export const MAX_COMMUNITY_CARD_EMAIL_LENGTH = 180;
export const MAX_COMMUNITY_PERSON_NAME_LENGTH = 255;

export const COMMUNITY_CARD_DELIVERY_METHODS = [DELIVERY_METHOD.EMAIL, DELIVERY_METHOD.TEXT] as const;

export const COMMUNITY_CARD_EMAIL_REGEX = /^\S+@\S+\.\S+$/;

export const CAMINO_COMMUNITY_SYNC_POLL_INTERVAL_MS = 2500;

export const CAMINO_COMMUNITY_SYNC_ALREADY_IN_PROGRESS_MESSAGE = 'Camino Community sync is already in progress';
export const CAMINO_COMMUNITY_SYNC_CONNECTION_NOT_FOUND_MESSAGE =
  'Active Camino connection was not found for the Church';
export const CAMINO_COMMUNITY_SYNC_LIST_NOT_FOUND_MESSAGE = 'Community list was not found';
export const CAMINO_COMMUNITY_SYNC_NOT_CAMINO_LIST_MESSAGE = 'Only a Camino Community list can be synchronized';

export const COMMUNITY_IMPORT_POLL_INTERVAL_MS = 10_000;

export const COMMUNITY_IMPORT_MAX_STATUS_POLL_FAILURES = 3;

export const COMMUNITY_IMPORT_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const COMMUNITY_IMPORT_SAMPLE_FILE_BY_KIND: Partial<Record<COMMUNITY_KIND, { url: string; fileName: string }>> =
  {
    [COMMUNITY_KIND.BUSINESS]: {
      url: '/community/business-import-template.csv',
      fileName: 'Business import template.csv',
    },
    [COMMUNITY_KIND.FAMILY]: {
      url: '/community/family-import-template.csv',
      fileName: 'Family import template.csv',
    },
  };

export const EMPTY_COMMUNITY_CARD_FORM_VALUES = {
  name: '',
  email: '',
  phone: '',
  deliveryMethods: [DELIVERY_METHOD.EMAIL] as DELIVERY_METHOD[],
  lists: [],
  people: [],
};
